import React, { ReactChild } from 'react';
import { Dropover, theme } from '@xometry/xometry_loft';
import { css } from '@emotion/react';

export interface TooltipBlueIconProps {
  children: ReactChild;
  alignment?: 'center' | 'left' | 'right' | undefined;
  minWidth?: string;
  placement?: 'bottom' | 'top' | undefined;
}

const TooltipBlueIcon = (props: TooltipBlueIconProps) => {
  const { children, alignment, minWidth, placement } = props;
  return (
    <Dropover alignment={alignment || 'left'} placement={placement || 'bottom'}>
      <Dropover.Trigger>
        <i
          className="far fa-info-circle"
          css={css`
            color: ${theme.colors.blues[100]};
            margin-left: 4px;
            font-size: 13px;
          `}
        />
      </Dropover.Trigger>
      <Dropover.Content
        fontWeight={theme.fontWeights.regular}
        fontSize="13px"
        padding="8px"
        minWidth={minWidth || '300px'}
      >
        {children}
      </Dropover.Content>
    </Dropover>
  );
};

export default TooltipBlueIcon;
